import { Circle } from 'ol/geom';
import OLFeature from 'ol/Feature';
import GeoJSON from 'ol/format/GeoJSON';
import { GeoJson } from '@ais-ui/api-spec/shapes';
import { Feature } from 'ol';
import { transform } from 'ol/proj';
import { getTrueToProjectedRadius } from '../calculateCircleRadius';
import { v4 as uuidv4 } from 'uuid';

const getIdFromShape = (shape: GeoJson): string | null | number => {
  if (shape.properties?.id) {
    return shape.properties.id;
  }

  return null;
};

export const shapeToFeature = (
  shape: GeoJson | undefined | null,
  displayProjection: string,
  dataProjection: string,
): Feature | null => {
  let feature: OLFeature | null = null;

  if (!shape) {
    return null;
  }

  const id = getIdFromShape(shape);
  if (shape.geometry?.type) {
    const geometryType = shape.geometry.type;
    if (geometryType === 'Point' && shape.properties?.radius) {
      const [lon, lat] = shape.geometry.coordinates;
      const center = transform([lon, lat], dataProjection, displayProjection);

      // The circle in 3857 projection needs to have the projected radius at the given latitude
      //  because of distortion in the projection
      const circle = new Circle(
        center,
        getTrueToProjectedRadius(
          shape.properties.radius,
          lat,
          displayProjection,
          dataProjection,
        ),
      );
      feature = new OLFeature(circle);
    } else {
      // Handle other geometries
      const format = new GeoJSON();
      feature = format.readFeature(shape.geometry, {
        dataProjection: dataProjection,
        featureProjection: displayProjection,
      });
    }
    if (feature) {
      feature.set('id', id || uuidv4());
      feature.set('name', shape.properties?.name || '');
      feature.set('description', shape.properties?.description || '');
      // Set type to 'shape' for context menu detection (if not already set)
      feature.set('type', shape.properties?.type || 'shape');

      Object.entries(shape.properties || {}).forEach(([key, value]) => {
        feature?.set(key, value);
      });
    }
  }

  return feature;
};
